import React from 'react';
import ReactDOM from 'react-dom';
import './components/main/react/index.css';
import reportWebVitals from './components/main/react/reportWebVitals';
import App from './components/main/react/App';

ReactDOM.render(<App />, document.getElementById('root'));

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
